import React, { memo } from 'react';
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';

const CheckBoxes = (props)=>{
  const {
    item,
    className,
    validationForms,
    fieldObj
  } = props;
  
  
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms);

  let readonlyVal = false;
  if(attr.fieldAttributes && attr.fieldAttributes.readOnly) {
     readonlyVal = attr.fieldAttributes.readOnly;
  }
  return (
    <FormBlocks {...props}  attr={attr} inputBlockClass={''}>
      <div className="custom-control custom-checkbox pb-2">
        <input 
            onChange={e => props.onChangeInputAction(fieldObj,e,'CheckBoxes')}
            checked={(attr.value==='true')?true:(attr.value==='TRUE' || attr.value===true)?true:(attr.value==='false')?false:attr.value}
            {...attr.fieldAttributes}
            type="checkbox" className="custom-control-input" name={'addForm_'+item.id} id={'addForm_'+item.id}  required="" />
            <label className="custom-control-label" htmlFor={readonlyVal === false ? 'addForm_'+item.id : null}></label>
      </div>
    </FormBlocks>
  );
}


CheckBoxes.defaultProps = {
  className: 'custom-control-input'
}


const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode){
    return true;
  }
}

export default memo(CheckBoxes,isDiffProps);